import React from 'react'
import { _ } from './i18n'

class Roster extends React.Component {

    sort( e ) {

        e.sort( ( a, b ) => {

            return (

                this.props.sort === 'name'

                ? ( a.lastName === b.lastName ? a.firstName.localeCompare( b.firstName ) : a.lastName.localeCompare( b.lastName ) )

                : ( ( Number( a.jerseyNr ) || Number.MAX_SAFE_INTEGER ) - ( Number( b.jerseyNr ) || Number.MAX_SAFE_INTEGER ) )

            )

        } )

    }

    render() {

        const roster  = []
        const dnps    = []
        const fillers = []

        this.props.roster.forEach( player => player.position && player.position.indexOf( '#DNP' ) !== -1 ? dnps.push( player ) : roster.push( player ) )

        for ( let i = 0; i < this.props.rows - this.props.roster.length; i++ ) { fillers.push( null ) }

        this.sort( roster )
        this.sort( dnps )

        return (

            <div className="roster">

                <table>

                    <thead>

                        <tr>

                            <td className="large bold" colSpan="6">{ this.props.team }</td>

                        </tr>

                        <tr>

                            <td className="large" colSpan="6">{ roster.length } { _( 'Players' ) }, { dnps.length } { _( 'PNP' ) }</td>

                        </tr>

                    </thead>

                    <tbody>

                        <tr>

                            <td>{ _( 'Pos.' ) }</td>
                            <td>{ _( '№' ) }</td>
                            <td>{ _( 'Name' ) }</td>
                            <td>{ _( 'Nat.' ) }</td>
                            <td>{ _( 'Y.o.B.' ) }</td>
                            <td>{ _( 'Class' ) }</td>

                        </tr>

                        { roster.map( ( e, i ) => <Row player={ e } key={ i } sort={ this.props.sort } /> ) }

                        <Row />

                        { dnps.length ? <tr><td colSpan="6" className="dnp">{ _( 'Present, not Playing (PNP)' ) }</td></tr> : <Row /> }
                        { dnps.map( ( e, i ) => <Row player={ e } key={ i } sort={ this.props.sort } /> ) }
                        { fillers.map( ( e, i ) => <Row key={ i } /> ) }

                    </tbody>

                </table>

            </div>

        )

    }

}

class Row extends React.Component {

    render() {

        const p = this.props.player

        const name = p ? ( this.props.sort === 'name' ? ( p.lastName && p.lastName.toUpperCase() + ( p.firstName ? ', ' + p.firstName : '' ) ) : ( p.firstName && p.firstName + ( p.lastName ? ' ' + p.lastName.toUpperCase() : '' ) ) ) : <>&nbsp;</>

        return (

            <tr>

                <td>{ p && p.position ? p.position.split( '#' )[ 0 ] : <>&nbsp;</> }</td>
                <td>{ p && Number( p.jerseyNr ) ? p.jerseyNr : <>&nbsp;</> }</td>
                <td>{ name }</td>
                <td>{ p && p.nation ? p.nation : <>&nbsp;</> }</td>
                <td>{ p && Number( p.yob ) ? p.yob : <>&nbsp;</> }</td>
                <td>{ p && p.classification ? p.classification : <>&nbsp;</> }</td>

            </tr>

        )

    }

}

export default Roster